var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-5"},[_c('v-card-title',[_vm._v("Page Views - Google Analytics")]),_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"600","height":"300","src":"https://lookerstudio.google.com/embed/reporting/9e3e8b94-5e70-48ea-8433-94b15923f224/page/ae9DD","frameborder":"0","allowfullscreen":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }